import axios from "../axios";

class CountryService {
  getCountries() {
    return axios
      .post(window.hostname + "api/auth/get-countries")
      .then((res) => (res.status === 200 ? res.data : []));
  }
  getStates(countryCode) {
    return axios
      .post(window.hostname + "api/auth/get-states", {
        country_code: countryCode,
      })
      .then((res) => (res.status === 200 ? res.data : []));
  }
}

export default new CountryService();
